// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAoUJHNcR1WvxiOAuqKrZpnNwaYpnxb96g",
  authDomain: "l2sportal-3aa64.firebaseapp.com",
  projectId: "l2sportal-3aa64",
  storageBucket: "l2sportal-3aa64.firebasestorage.app",
  messagingSenderId: "547442675494",
  appId: "1:547442675494:web:42ca414035174f03557be7",
  measurementId: "G-NEERXN5SY5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Initialize Google Auth Provider
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account",
});

export { auth, analytics, googleProvider };
